import { render, staticRenderFns } from "./AnnotationWorkImport.vue?vue&type=template&id=b27842f8&"
import script from "./AnnotationWorkImport.vue?vue&type=script&lang=js&"
export * from "./AnnotationWorkImport.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationWorkImport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports